import React from 'react';
import { Box, Text, Icon, Flex, useColorMode } from '@chakra-ui/react';
import { Container } from 'components/Container';
import { MdArrowBack } from 'react-icons/md';
import { bgColorB, borderColor, colorText } from 'config/data';

const BackStep = ({ setStep, data }) => {
  const { colorMode } = useColorMode();
  return (
    <Box
      borderBottomWidth={1}
      borderColor={borderColor[colorMode]}
      p="15px"
      bg={colorMode === 'dark' ? '#141414' : '#fcfcfc'}
      color={colorText[colorMode]}
    >
      <Container>
        <Flex px={{ base: '0px', md: '50px' }} onClick={() => setStep(1)}>
          <Icon as={MdArrowBack} cursor="pointer" fontSize="22px" mr="10px" />
          <Text fontSize="14px" fontWeight="500" cursor="pointer">
            Back
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default BackStep;
